import { useEffect, useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { api, formatErr, imgUrl } from "@/lib/api";
import { ImageUploader } from "./ImageUploader";

/** Foto delle categorie: vivono sulla categoria (non nella pagina), quindi si salvano subito. */
export const CategoryCoversField = ({ id }) => {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/categories").then((r) => setItems(r.data.items));
  useEffect(() => { load(); }, []);

  const save = async (it, cover) => {
    try {
      await api.put(`/admin/categories/${it.id}`, { event_type: it.event_type, title: it.title, intro: it.intro, cover, order: it.order, visible: it.visible });
      toast.success(cover ? `Foto di ${it.title} aggiornata` : `Foto di ${it.title} rimossa`);
      load();
    } catch (e) { toast.error(formatErr(e)); }
  };

  return (
    <div className="space-y-3" data-testid={id}>
      <p className="text-xs text-slate-500">Una foto per categoria. Le modifiche qui si salvano subito, senza bisogno di pubblicare la pagina.</p>
      {items.map((it, k) => (
        <div key={it.id} className="flex items-center gap-3 border border-line rounded p-3" data-testid={`${id}-row-${k}`}>
          <div className="relative w-24 h-20 bg-cream rounded overflow-hidden shrink-0">
            {it.cover && <img src={imgUrl(it.cover)} alt="" className="w-full h-full object-cover" />}
            {it.cover && <button type="button" onClick={() => save(it, "")} className="absolute top-1 right-1 bg-white/90 rounded p-1 text-terracotta" aria-label="Rimuovi" data-testid={`${id}-clear-${k}`}><X size={12} /></button>}
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold">{it.title}</p>
            <p className="text-[11px] text-slate-500 truncate">{it.visible ? `/${it.page_slug}` : "nascosta dal sito"}</p>
          </div>
          <ImageUploader multiple={false} label={it.cover ? "Sostituisci" : "Carica foto"} onUploaded={(u) => save(it, u[0])} testid={`${id}-upload-${k}`} />
        </div>
      ))}
      {!items.length && <p className="text-sm text-slate-500">Nessuna categoria. Creale da Impostazioni → Categorie.</p>}
      <p className="text-xs text-slate-500">Per aggiungere o eliminare una categoria (con pagina e voce di menu): Impostazioni → Categorie.</p>
    </div>
  );
};
